var React = require('react');

function Pipedrive (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"0.939941","width":"16","height":"16.1203","rx":"8","fill":"#017737","key":0}),React.createElement("path",{"d":"M11.4138 7.95619C11.4138 9.65228 10.3276 10.8123 8.77449 10.8123C8.03616 10.8123 7.42765 10.5058 7.19983 10.1227L7.21061 10.5166V12.9457H5.62517V6.66488C5.62517 6.5775 5.60361 6.55529 5.50562 6.55529H4.96228V5.22054H6.28756C6.89558 5.22054 7.04795 5.74575 7.09106 5.97578C7.33015 5.57101 7.95973 5.10059 8.85043 5.10059C10.382 5.10009 11.4138 6.24875 11.4138 7.95619ZM9.79553 7.96705C9.79553 7.05879 9.20907 6.43534 8.47024 6.43534C7.86223 6.43534 7.17778 6.84011 7.17778 7.9784C7.17778 8.72229 7.59031 9.49926 8.44868 9.49926C9.07875 9.49876 9.79553 9.0392 9.79553 7.96705Z","fill":"white","key":1})]);
}

Pipedrive.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none"};

module.exports = Pipedrive;

Pipedrive.default = Pipedrive;
